import React from "react";
import "./styles.scss";
import {
  Button, ButtonColour, ButtonSize, Typography,
} from "@trussle/external-components";
import { StaticImage } from "gatsby-plugin-image";
import { IContentfulHeroProps } from "../../types/IHero";
import { trackEvent } from "../../helpers/analytics";
import { getPlainText } from "../../utils/getPlainText";
import Lock from "./lock.svg";
import House from "./house.svg";
import { Trustpilot, TrustpilotTemplates } from "../Trustpilot";

const Houses = ({ className }: {className: string}) => (
  <div className={className}>
    <img src={House} alt="" />
    <img src={House} alt="" />
    <img src={House} alt="" />
    <img src={House} alt="" />
  </div>
);

const Hero6: React.FC<IContentfulHeroProps> = ({
  heading1,
  heading2,
  disclaimerText,
}) => {
  const handleBuyClick = async () => {
    await trackEvent("Buy clicked", {
      module: "Hero6",
      element_type: "Button",
      section: "Megabutton",
    });
    window.location.assign("/ff1/purchase/purchase-stage");
  };
  const handleRemortgageClick = async () => {
    await trackEvent("Remortgage clicked", {
      module: "Hero6",
      element_type: "Button",
      section: "Megabutton",
    });
    window.location.assign("/get-started/remaining-term");
  };
  const handleSecuredLoansClick = async () => {
    await trackEvent("Secured loans clicked", {
      module: "Hero6",
      element_type: "Button",
      section: "SecuredLoansBanner",
    });
    window.location.assign("/secured-loans");
  };

  return (
    <div className="hero6__container">
      <StaticImage
        src="./bg-image-left.png"
        className="hero6__background__image__left"
        alt=""
        placeholder="none"
        width={350}
        quality={90}
      />
      <div className="hero6">
        <section className="hero6__heading" aria-label="Hero heading">
          <Typography variant="h1" component="h1" classes="hero6__title">{heading1 && getPlainText(heading1)}</Typography>
          <Typography variant="body2" component="p" classes="hero6__subtitle">{heading2 && getPlainText(heading2)}</Typography>
        </section>
        <section className="hero6__buttons" aria-label="Hero buttons">
          <Button
            classOverrides={{ button: "hero6__button__buy" }}
            testIds={{ button: "buy-button" }}
            onClick={handleBuyClick}
            size={ButtonSize.Large}
            colour={ButtonColour.DarkYellow}
          >
            I’m buying a home
          </Button>
          <Button
            className="hero6__button__remortgage"
            testIds={{ button: "remortgage-button" }}
            onClick={handleRemortgageClick}
            size={ButtonSize.Large}
            colour={ButtonColour.Black}
          >
            I’m remortgaging
          </Button>
        </section>
        {
          disclaimerText && (
          <p className="hero6__disclaimer">
            <img src={Lock} alt="lock" />
            <span className="hero6__disclaimer__text">{getPlainText(disclaimerText)}</span>
          </p>
          )
        }
        <Trustpilot template={TrustpilotTemplates.MicroCombo} className="hero6__trustpilot" isInViewFromStart />
      </div>
      <div className="hero6__secured-loans">
        <span className="hero6__secured-loans__description">Unlock equity in your home with a secured loan</span>
        <button className="hero6__secured-loans__cta" onClick={handleSecuredLoansClick} type="button">Apply now</button>
        <div className="hero6__secured-loans__houses">
          <Houses className="hero6__secured-loans__houses__bottom" />
          <Houses className="hero6__secured-loans__houses__middle" />
          <Houses className="hero6__secured-loans__houses__top" />
          <Houses className="hero6__secured-loans__houses__top-mobile" />
        </div>
      </div>
      <StaticImage
        src="./bg-image-right.png"
        className="hero6__background__image__right"
        alt=""
        placeholder="none"
        width={350}
        quality={90}
      />
    </div>
  );
};

export default Hero6;
